import React from 'react';
import {withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

const subjects = [ // may be, this can come from server    
    { label: "Math", value: "M" },
    { label: "Reading", value: "R" },
    { label: "Math & Reading", value: "M_R" },
];

/*
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 140,
        width: 300
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));
*/

const useStyles = theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 140,
        width: 300
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});


class subjectDropDown extends React.Component {

    constructor(props) {
        super(props);        
        this.state = {
            selectedValue: this.props.value
        }
        this.readOnly = this.props.readOnly;  
    }

    onChange = event => {
        // console.log(`subjectDropDown:onChange : ${event.target.id} :  ${event.target.value}`)        
        if (this.props.onChange && (this.readOnly === false)) {
            this.props.onChange(this.props.id, event.target.value);
        }
    }

    getTextValue() {
        if(this.readOnly === true) {
            return subjects.find(element => element.value === this.state.selectedValue).label;
        }
        else {
            return this.state.selectedValue;
        }

    }
    getSelect() {
        return this.readOnly === true ? false : true;        
    }


    render() {
        // selected={index === this.state.selectedIndex}
        let readOnly = this.readOnly
        return (
            <TextField style={{ minWidth: 240 }} fullWidth
                defaultValue={this.getTextValue()}
                id={this.props.id}
                select={this.getSelect()}
                label="Subject(s)"
                onChange={this.onChange}
                helperText=""
                variant="outlined"
                InputProps={{
                    readOnly:readOnly
                  }}                
                >
                {subjects.map((option, index) => (
                    <MenuItem key={option.value} value={option.value} >
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        )
    }

}


//export default subjectDropDown;

export default withStyles(useStyles)(subjectDropDown)


